import {
    SET_PLAYER_TEXT,
    SET_PLAYERS_TEXT,
    SET_TESTSERVER_TEXT,
    SET_TESTSERVERWARNING_TEXT,
    SET_ONTESTSERVER_TEXT,
    SET_TEXTS,
} from './constants'

const initialState = {
    player: '',
    players: '',
    testServer: '',
    testServerWarning: '',
    onTestServer: '',
}

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case SET_PLAYER_TEXT: {
            return {
                ...state,
                player: action.payload,
            }
        }

        case SET_PLAYERS_TEXT: {
            return {
                ...state,
                players: action.payload,
            }
        }

        case SET_TESTSERVER_TEXT: {
            return {
                ...state,
                testServer: action.payload,
            }
        }

        case SET_TESTSERVERWARNING_TEXT: {
            return {
                ...state,
                testServerWarning: action.payload,
            }
        }

        case SET_ONTESTSERVER_TEXT: {
            return {
                ...state,
                onTestServer: action.payload,
            }
        }

        case SET_TEXTS: {
            return action.payload
        }

        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/features/ServerMenu/data/texts/reducer.js